import { swalAlertPopProps } from "../../utils/commonUtils";

export const addNewVendor = async (addVendor, payload, callback) => {
  await addVendor(payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.log("err ", err);
    });
};

export const getVendorList = async (getVendor, setVendorsList) => {
  await getVendor()
    .then((res) => {
      setVendorsList(res?.data?.data?.list);
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const updateExistingVendor = async (updateVendor, payload, callback) => {
  await updateVendor(payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.log("err ", err);
    });
};